<template>

<v-container>
  <v-snackbar xs12
    v-model="snackbar"
    multi-line
    :timeout="timeout"
    top
    color="orange"
  >
    {{ alertmessage }}
    <v-btn
      color="white"
      text
      @click="snackbar = false"
    >
      Close
    </v-btn>
  </v-snackbar>      
<v-row>
  <v-col>
    <v-progress-linear
      :active="loading"
      :indeterminate="loading"
      absolute
      color="primary"
    ></v-progress-linear>
  </v-col>
</v-row>      
<v-row wrap> 
  
  <v-col>


    <base-material-card
      v-if="!loading"
      color="primary"
      icon="mdi-bank"
      inline
    >
    <template v-slot:after-heading>
      <div class="display-2 font-weight-light">
        Sites Services & Invoice Settings
      </div> 

    </template>    
<v-row>
  <v-spacer></v-spacer>
            <v-btn
            
            color="primary"
            size="20"
            @click="editItem(item)"
          >
          edit item
          </v-btn>
</v-row>
    
    <v-row>
      
      <v-col
      sm="12"
      >
        <v-card
          class="pa-2"
          outlined
          tile
        >
      <v-dialog v-model="dialog" max-width="600px">
        <v-card>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                
                <sequential-entrance fromLeft> 
                  <v-row>
                    <v-col>
                     Pick Up Options
                  <v-radio-group
                    v-model="pickuptype"
                  >
                    <v-radio
                      label="Armored Car Service"
                      value="Armored Car Service"
                    ></v-radio>
                    <v-radio
                      label="Postal Deposits"
                      value="Postal Deposits"
                    ></v-radio>
                  </v-radio-group> 
                                    
                  Safe Type
                  <v-radio-group
                    v-model="safetype"
                    row
                  >
                    <v-radio
                      label="Smart Safe"
                      value="Smart Safe"
                    ></v-radio>
                    <v-radio
                      label="Virtual Safe"
                      value="Virtual Safe"
                    ></v-radio>
                  </v-radio-group>   
                  </v-col>
                  <v-row>
                    
                   <v-col>
                     Pick Up Days
                    <v-checkbox
                      v-model="pickupschedule"
                      label="Monday"
                      color="primary"
                      value="Mon"
                      hide-details
                    ></v-checkbox>
                    <v-checkbox
                      v-model="pickupschedule"
                      label="Tuesday"
                      color="primary"
                      value="Tue"
                      hide-details
                    ></v-checkbox>
                    <v-checkbox
                      v-model="pickupschedule"
                      label="Wednesday"
                      color="primary"
                      value="Wed"
                      hide-details
                    ></v-checkbox> 
                    <v-checkbox
                      v-model="pickupschedule"
                      label="Thursday"
                      color="primary"
                      value="Th"
                      hide-details
                    ></v-checkbox> 
                    <v-checkbox
                      v-model="pickupschedule"
                      label="Friday"
                      color="primary"
                      value="Fri"
                      hide-details
                    ></v-checkbox>    
                    <v-checkbox
                      v-model="pickupschedule"
                      label="Saturday"
                      color="primary"
                      value="Sat"
                      hide-details
                    ></v-checkbox>
                    <v-checkbox
                      v-model="pickupschedule"
                      label="Sunday"
                      color="primary"
                      value="Sun"
                      hide-details
                    ></v-checkbox>                                                                              
                  </v-col>
                   <v-col>
                     Change Order Days
                    <v-checkbox
                      v-model="orderschedule"
                      label="Monday"
                      color="primary"
                      value="Mon"
                      hide-details
                    ></v-checkbox>
                    <v-checkbox
                      v-model="orderschedule"
                      label="Tuesday"
                      color="primary"
                      value="Tue"
                      hide-details
                    ></v-checkbox>
                    <v-checkbox
                      v-model="orderschedule"
                      label="Wednesday"
                      color="primary"
                      value="Wed"
                      hide-details
                    ></v-checkbox> 
                    <v-checkbox
                      v-model="orderschedule"
                      label="Thursday"
                      color="primary"
                      value="Th"
                      hide-details
                    ></v-checkbox> 
                    <v-checkbox
                      v-model="orderschedule"
                      label="Friday"
                      color="primary"
                      value="Fri"
                      hide-details
                    ></v-checkbox>    
                    <v-checkbox
                      v-model="orderschedule"
                      label="Saturday"
                      color="primary"
                      value="Sat"
                      hide-details
                    ></v-checkbox>
                    <v-checkbox
                      v-model="orderschedule"
                      label="Sunday"
                      color="primary"
                      value="Sun"
                      hide-details
                    ></v-checkbox>                                                                              
                  </v-col>                                  
                  </v-row>
                 

                </v-row>

                </sequential-entrance>

              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="warning" @click="close">Cancel</v-btn>
            <v-btn color="primary" @click="save" >Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    <v-row>
      <v-col
        cols="12"
        sm="6"
        lg="6"
      >
        <base-material-stats-card
          color="red"
          icon="mdi-safe-square-outline"
          elevation = "3"
          title="Safe Type"
          :value="safetype"
          sub-icon="mdi-chevron-right"
          sub-text="Physical/Virtual"
        />
      </v-col> 
      <v-col
        cols="12"
        sm="6"
        lg="6"
      >
        <base-material-stats-card
          color="brown"
          icon="mdi-transfer-right"
          title="Collection Method"
          elevation = "3"
          :value="pickuptype"
          sub-icon="mdi-chevron-right"
          sub-text="Armored Car/Postal"
        />
      </v-col>      
    </v-row>
    <v-row>
      <v-col
        cols="12"
        sm="6"
        lg="6"
      >
        <base-material-stats-card
          color="blue"
          icon="mdi-calendar"
          title="Collection Schedule"
          elevation = "3"
          :value="displayPickup"
          sub-icon="mdi-chevron-right"
          sub-text="Collection Days"
        />
      </v-col>
      <v-col
        cols="12"
        sm="6"
        lg="6"
      >
        <base-material-stats-card
          color="green"
          icon="mdi-calendar"
          title="Change Order Days"
          elevation = "3"
          :value="displayOrders"
          sub-icon="mdi-chevron-right"
          sub-text="Days available"
        />
      </v-col>     
    </v-row>    
    <v-row>

      <v-col
        cols="12"
        sm="12"
        lg="12"
      >
        <base-material-card
          color="yellow darken-2"
          icon="mdi-map-marker"
          title="Billing Information"
          elevation = "3"
          :value="billinginfo"
          sub-icon="mdi-calendar"
          sub-text="Billing Cycle"
        >
        <v-row>
        <v-col
        xs="6">

      <div class="display-2 font-weight-light">
        Attn James Kelly
      </div>
      <div class="display-2 font-weight-light">
        1123 Tallinn Way, Tallinn, New York 10001
      </div>
      <div class="display-2 font-weight-light">
        555-1232
      </div>
        </v-col>
        <v-col
        xs="6"
        >
      <div class="display-2 font-weight-light">
        Direct Debt
      </div> 
      <div class="display-2 font-weight-light">
        Term: 1 year  Jan 1, 2020 to Dec 31, 2020
      </div> 
      <div class="display-2 font-weight-light">
        Account Number: 9999234234
      </div>           
        </v-col>
        </v-row>
        </base-material-card>
      </v-col>  
 
    </v-row>   


        </v-card>
      </v-col>     
    </v-row>    
    </base-material-card>

    <v-spacer></v-spacer>    
  </v-col>

</v-row>
    </v-container>

 
</template>

<script>
  // Components

  export default {
    data: () => ({
      search: '',
      dialog: false,
      snackbar: false,
      timeout: 5000,
      alertmessage: '',
      collectiontype: 'car service',
      safetype: 'Smart Safe',
      contractStart: '',
      contractEnd: '',
      pickuptype: 'sdfd',
      pickupschedule: [],
      orderschedule: [],
      virtualsafe: false,
      smartsafe: true,
      postalservice: true,
      carservice: false,
      currentgroups: '',
      externalsafe: false,
      menu2: false,
      menu3: false,
      menu4: false,
      menu5: false,
      modal2: false,
      loading: false,
      headers: [     
        { text: 'Site Name', value: 'idnum', align: 'left', width:120 },
        { text: 'Group', value: 'group', align: 'left' },
        { text: 'External ID', value: 'group', align: 'center' },
        { text: 'Provisional Credit', value: 'credit', align: 'center'},
        { text: 'Smart Safe', value: 'smartsafe', align: 'center' },
        { text: 'Virtual Safe', value: 'virtual', align: 'center' },
        { text: 'Armored Car Pickup', value: 'carservice', align: 'center' },
        { text: 'Postal Pickup', value: 'postal', align: 'center' },
        { text: 'Cost/Month', value: 'cost', align: 'center' },
        { text: 'Actions', value: 'action', sortable: false, width: 100 }
      ],
      sites: [],

    }),

    computed: {
      services() {
        // this.sites = this.$store.getters.siteservices
        // { text: 'Provisional Credit', value: 'credit', align: 'left'},
        // { text: 'Smart Safe', value: 'smartsafe', align: 'left' },
        // { text: 'Virtual Safe', value: 'virtual', align: 'left' },
        // { text: 'Armored Car Pickup', value: 'carservice', align: 'center' },
        // { text: 'Postal Pickup', value: 'postal', align: 'center' },
        // { text: 'Monthly', value: 'cost', align: 'center' },
        this.siteservices = [{
          idnum: 'buds place',
          externalid: '234hsdfhkh',
          group: 'something',
          sitekey: '123234kjhskdf',
          credit: 'active',
          smartsafe: 'active',
          virtual: 'no',
          carservice: 'yes',
          pickupschedule: [],
          orderdays: [],
          postal: 'no',
          cost: 0
        }]
        return this.siteservices
      },
      currentmachines () {
        this.sites = this.$store.getters.loadedSites
        return this.sites
      },
      displayPickup () {
        let days = ""
        for (let day of this.pickupschedule) {
          days +=  day + " "
        }
        return days
      },
      displayOrders () {
        let days = ""
        for (let day of this.orderschedule) {
          days +=  day + " "
        }
        return days
      }
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      loading (val) {
        if (!val) return

        setTimeout(() => (this.loading = false), 1000)
      }      
    },
    created () {
      this.loading = true
      this.$store.dispatch('loadunits')
      this.$store.dispatch('loadsiteProfiles')
      this.$store.dispatch('loadSiteConfigs')
      this.$store.dispatch('loadUserProfiles')
      this.$log.debug('SITES LOADED: ', this.$store.getters.loadedSites)
      this.sites = this.$store.getters.loadedSites
      this.tokens = this.$store.getters.loadedTokens
      this.$log.debug('this sites is: ', this.sites)
    },

    methods: {
      userlist (group) {
        this.$log.debug('%%%%% group passed is ', group)
        let people = this.$store.getters.userprofiles
        this.$log.debug('people rec is ', people)
        let usersfromgroup = people.filter(person => person.group === group)
        return usersfromgroup.map(usr => usr.email)
      },
      addgroup () {
        this.$log.debug('want to add group ', this.newgroup)
        if (this.newgroup) {
          // this.currentgroups.push(this.newgroup)
          this.$log.debug('I am adding group ', this.newgroup)
          this.$store.dispatch('createUserGroup', this.newgroup)
          // make sure to load on a good add to the db
          this.$store.dispatch('loadUserGroups')
          this.newgroup = ''
        }
      },
      removeGroup (index) {
        let numelements = 1
        let grp = this.currentgroups[index]
        this.currentgroups.splice(index, numelements)
        this.$store.dispatch('removeUserGroup', grp)
        this.$store.dispatch('loadUserGroups')
      },
      editItem (item) {
        this.editedIndex = this.sites.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
        this.$log.debug('this is an edit')
      },
      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      save () {
        this.close()
      }
    }
  }
</script>
<style>
  .card--flex-toolbar {
    margin-top: -64px;
  }
</style>
